const envSettings = window
// export class Config {
//   static edit_expiration_threshold = envSettings.EDIT_EXPIRATION_THRESHOLD
//   static mfa_guide_url = envSettings.MFA_GUIDE_URL
//   static service_url = envSettings.SERVICE_URL
//   static dashboard_url = envSettings.DASHBOARD_URL
//   static email_service = envSettings.EMAIL_SERVICE
//   static analytics_service_url = envSettings.ANALYTICS_SERVICE_URL
//   static user_manual_url = envSettings.USER_MANUAL_URL
//   static data_dictionary_url = envSettings.DATA_DICTIONARY_URL
//   static version_num = envSettings.VERSION_NUM
//   static mailto_list = envSettings.MAILTO_LIST
//   static request_config = envSettings.REQUEST_CONFIG
// };
export const namespace = '1b0db098-ef29-468a-98be-40d58c91b2c0'

export const edit_expiration_threshold = envSettings.EDIT_EXPIRATION_THRESHOLD
export const mfa_guide_url = envSettings.MFA_GUIDE_URL
export const service_url = envSettings.SERVICE_URL
export const dashboard_url = envSettings.DASHBOARD_URL
export const email_service = envSettings.EMAIL_SERVICE
export const analytics_service_url = envSettings.ANALYTICS_SERVICE_URL
export const user_manual_url = envSettings.USER_MANUAL_URL
export const data_dictionary_url = envSettings.DATA_DICTIONARY_URL
export const version_num = envSettings.VERSION_NUM
export const mailto_list = envSettings.MAILTO_LIST
export const request_config = envSettings.REQUEST_CONFIG
